// extracted by mini-css-extract-plugin
export default {"eye_chart_font":"visualAcuity_eye_chart_font__D3Ytj","snellen_chart_font":"visualAcuity_snellen_chart_font__u7a7d","sloan_chart_font":"visualAcuity_sloan_chart_font__n9iJd"};